module.exports = __webpack_public_path__ + "static/media/mt-ut-img-12.e8bd9bd2.png";